import {displayErrors} from "../../../utils";
import React from "react";

type ErrorProps = {
    errors: Array<{title: string; message: string}> | null;
}

const Error = ({errors}: ErrorProps) => {
    return (
        <>
            {
                errors ?
                    <div className='flex items-center justify-center w-full pt-4 text-red-500 whitespace-pre-wrap'>
                        {displayErrors(errors)}
                    </div> : null
            }
        </>
    )
}

export default Error;
